import familyService from '@/apis/family/service';
import * as React from 'react';

export interface ITitleFamilyProps {}

export default function TitleFamily(props: ITitleFamilyProps) {
  const { data } = familyService.useGetFamilies({ limit: 1 });
  const total = data?.meta?.total || 0;

  return (
    <div className="cms-h1 mb-4 flex items-center">
      Danh sách hộ gia đình
      <div className="cms-sub1 py-[2px] px-2 rounded-lg bg-violet-10 ml-2 text-white">{total} Hộ gia đình</div>
    </div>
  );
}
